/**
 * @generated SignedSource<<8af5a7b089d2ecb23d019050a1b3f7b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type BrandMessageTaskCreateInput = {
  csvFile?: Upload | null;
  description?: string | null;
  period?: number | null;
  query: string;
  startAt: any;
  templateId: string;
  title: string;
};
export type Upload = {
  fieldName?: string | null;
  key: string;
  multipartUploadResult?: MultiPartUploadResult | null;
  objectUrl?: string | null;
  size: number;
};
export type MultiPartUploadResult = {
  partPairs: ReadonlyArray<PartPair>;
  uploadId: string;
};
export type PartPair = {
  ETag: string;
  PartNumber: number;
};
export type BrandMessageTaskCreateDialog_brandMessageTaskCreateMutation$variables = {
  input: BrandMessageTaskCreateInput;
};
export type BrandMessageTaskCreateDialog_brandMessageTaskCreateMutation$data = {
  readonly brandMessageTaskCreate: {
    readonly id: string;
  };
};
export type BrandMessageTaskCreateDialog_brandMessageTaskCreateMutation = {
  response: BrandMessageTaskCreateDialog_brandMessageTaskCreateMutation$data;
  variables: BrandMessageTaskCreateDialog_brandMessageTaskCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "BrandMessageTask",
    "kind": "LinkedField",
    "name": "brandMessageTaskCreate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BrandMessageTaskCreateDialog_brandMessageTaskCreateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BrandMessageTaskCreateDialog_brandMessageTaskCreateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "509a4e9ca2012c3610830d289b779bdf",
    "id": null,
    "metadata": {},
    "name": "BrandMessageTaskCreateDialog_brandMessageTaskCreateMutation",
    "operationKind": "mutation",
    "text": "mutation BrandMessageTaskCreateDialog_brandMessageTaskCreateMutation(\n  $input: BrandMessageTaskCreateInput!\n) {\n  brandMessageTaskCreate(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3bc0c521a6bcb8716ab6f29ec6611e81";

export default node;
